import StyledIcon from "../StyledIcon";

const WaDownload = props => {
    return <StyledIcon width="23" height="26" viewBox="0 0 23 26" fill="none" {...props}>
        <path d="M11.5234 0.357422V17.3574M21.5234 8.35742L11.5234 18.3574L1.52344 8.35742M1.52344 24.3574L21.5234 24.3574" strokeWidth="2" strokeLinejoin="round" />
    </StyledIcon>

}

export default WaDownload;